<template>
  <div class="mylesson">
    <my-study-nav></my-study-nav>
    <div class="content-right">
      <h2 class="top-title">测试上课设备</h2>
      <section class="test-wrapper">
        <p class="test-title">为了保证您能正常上课，需要检测您的摄像头、扬声器是否正常</p>
        <section class="testimg-wrapper">
          <section class="img-wrapper margin">
            <img class="img" src="./sound.png" alt="img" width="44" height="44">
          </section>
          <section class="img-wrapper">
            <img class="img" src="./video.png" alt="img" width="44" height="44">
          </section>
        </section>
        <button class="test-btn" @click="openTestUrl">开始测试</button>
      </section>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import MyStudyNav from 'components/mystudynav/MyStudyNav'
  export default{
    methods: {
      openTestUrl(){
        window.open('https://edu.9man.com/liveroom/device.html');
      },
    },
    components: {
      MyStudyNav,
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .mylesson
    margin: 10px auto 40px
    width: 1226px
    min-height: calc(100vh - 385px)
    box-sizing border-box
    overflow: hidden
    font-size: 0
    .content-right
      float: right
      width: 966px
      .top-title {
        height: 68px
        line-height: 68px;
        padding-left: 20px;
        font-size: 24px;
        font-weight: bold
        color: #333;
        background: #fff;
      }
      .test-wrapper
        margin-top: 10px;
        text-align: center
        background: #ffffff
        padding-top: 90px
        height: 440px;
        box-sizing: border-box
        .test-title
          font-size: 18px
          color: #333333
          line-height: 25px
          height: 25px
          margin-bottom: 40px
        .testimg-wrapper
          margin: 0 auto
          width: 276px
          height: 98px
          .img-wrapper
            float: left
            width: 98px
            height: 98px
            border: 1px solid #ff6700
            border-radius: 50px
            box-sizing: border-box
            &.margin
              margin-right: 80px
            .img
              position: relative
              top: 26px
        .test-btn
          margin: 50px auto 0
          display: block
          width: 180px
          height: 46px
          line-height: 46px
          color: #ffffff
          font-size: 16px
          background: #ff6700
          border-radius: 23px
</style>



// WEBPACK FOOTER //
// src/page/account/personal/testurl/TestUrl.vue